module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticStyle: {
      "max-width": "1024px"
    }
  }, [_c('v-card', {
    staticStyle: {
      "padding-left": "16px",
      "padding-right": "16px",
      "padding-top": "8px",
      "padding-bottom": "8px"
    }
  }, [(_vm.showSuccessAlert) ? _c('div', [_c('v-alert', {
    attrs: {
      "success": "",
      "value": _vm.showSuccessAlert,
      "transition": "scale-transition"
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.successAlert) + "\n\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "heading-small",
    staticStyle: {
      "padding-top": "32px"
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(this.lng.yourMessage) + "\n\t\t\t\t")]), _vm._v(" "), _c('v-card', {
    staticStyle: {
      "padding-left": "32px",
      "padding-right": "32px",
      "padding-top": "16px",
      "padding-bottom": "16px",
      "margin-bottom": "16px"
    }
  }, [_c('v-layout', {
    attrs: {
      "row-sm": "",
      "column": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(this.lng.name) + ":")]), _vm._v(" "), _c('v-flex', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "8px"
    },
    attrs: {
      "xs12": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(this.lng.mail) + ":")]), _vm._v(" "), _c('v-flex', [_vm._v(_vm._s(_vm.mail))]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "8px"
    },
    attrs: {
      "xs12": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(this.lng.phonenumber) + ":")]), _vm._v(" "), _c('v-flex', [_vm._v(_vm._s(_vm.tel))]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "8px"
    },
    attrs: {
      "xs12": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(this.lng.prefContact) + ":")]), _vm._v(" "), _c('v-flex', [_vm._v(_vm._s(_vm.pref))]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "8px"
    },
    attrs: {
      "xs12": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "16px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.message) + "\n\t\t\t\t\t")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.showSuccessAlert) ? _c('div', [_c('v-layout', {
    attrs: {
      "row-md": "",
      "column": ""
    }
  }, [_c('v-flex', {
    staticClass: "long-text grey--text text--darken-1",
    attrs: {
      "md4": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('h1', {
    staticClass: "heading-big grey--text text--darken-1"
  }, [_vm._v(_vm._s(this.lng.contact))]), _vm._v("\n\t\t\t\t\t\t\t\tHaplabit UG (haftungsbeschränkt)"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\tEchterstraße 8a"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\tD-97209 Veitshöchheim"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\tTel.: +49 1522 8619 710"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\tEmail:  info@hapla.eu"), _c('br')]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "spacing-32 hidden-sm-and-down"
  }), _vm._v(" "), _c('div', {
    staticClass: "spacing-32 hidden-sm-and-up"
  }), _vm._v(" "), _c('div', {
    staticClass: "heading",
    staticStyle: {
      "padding-bottom": "8px"
    }
  }, [_vm._v(_vm._s(this.lng.imprint))]), _vm._v("\n\t\t\t\t\t\t\t\tAmtsgericht Würzburg. HRB 15269"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\tGeschäftsführung: Dipl. – Ing. Harald Samoticha"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\tUSt.-ID: DE338177997"), _c('br')])], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-and-up",
    staticStyle: {
      "padding-top": "64px"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md8": "",
      "sm12": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "padding-left": "16px",
      "padding-right": "16px",
      "padding-top": "16px",
      "padding-bottom": "16px"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": this.lng.name,
      "prepend-icon": "person",
      "required": "",
      "rules": [_vm.nameErr]
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": this.lng.mail,
      "prepend-icon": "mail",
      "rules": [_vm.mailErr]
    },
    model: {
      value: (_vm.mail),
      callback: function($$v) {
        _vm.mail = $$v
      },
      expression: "mail"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": this.lng.phonenumber,
      "prepend-icon": "phone",
      "rules": [_vm.telErr]
    },
    model: {
      value: (_vm.tel),
      callback: function($$v) {
        _vm.tel = $$v
      },
      expression: "tel"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row-sm": "",
      "column": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticClass: "grey--text text--darken-1"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(this.lng.preference) + "\n\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', [_c('v-radio', {
    attrs: {
      "label": this.lng.phone,
      "value": "Rückruf (Telefon)",
      "color": "primary"
    },
    model: {
      value: (_vm.pref),
      callback: function($$v) {
        _vm.pref = $$v
      },
      expression: "pref"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-radio', {
    attrs: {
      "label": this.lng.mail,
      "value": "E-Mail",
      "color": "primary"
    },
    model: {
      value: (_vm.pref),
      callback: function($$v) {
        _vm.pref = $$v
      },
      expression: "pref"
    }
  })], 1)], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.lng.message,
      "multi-line": "",
      "required": "",
      "rules": [_vm.messageErr]
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.send()
      }
    }
  }, [_vm._v(_vm._s(this.lng.send))])], 1)], 1)], 1)], 1) : _vm._e()])], 1), _vm._v(" "), (!_vm.showSuccessAlert) ? _c('div', {
    staticClass: "spacing-128"
  }) : _vm._e(), _vm._v(" "), (_vm.showSuccessAlert) ? _c('div', {
    staticStyle: {
      "height": "1200px"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-829ec096"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Kontakt.vue
// module id = 160
// module chunks = 1 2